import React from 'react';
import {connect} from 'react-redux'
import { Router as ReactRouter } from 'react-router';
import { BrowserRouter, Routes, Route, Navigate, createBrowserRouter } from 'react-router-dom';
import { createBrowserHistory, BrowserHistory } from 'history'
import { store } from './Store'
import { RouteWithLayout } from './components';
import { PrivateRoute, AdminRoute, DmAdminRoute } from './hocs'
import { Main as MainLayout, Minimal as MinimalLayout, Auth as AuthLayout, Admin as AdminLayout, DMAdmin as DMAdminLayout, Blank as BlankLayout } from './layouts';
// import { history } from './history'
// import { history } from './history'
// import history from "history/browser";


import {
  Analytics as AnalyticsView,
  Dashboard as DashboardView,
  DashboardOld as DashboardOldView,
  ProductList as ProductListView,
  UserList as UserListView,
  Typography as TypographyView,
  Icons as IconsView,
  AccountList as AccountListView,
  AccountAdd as AccountAddView,
  AccountEdit as AccountEditView,
  AccountView,
  UserAdd as UserAddView,
  UserEdit as UserEditView,
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,
  MerchantList as MerchantListView,
  DeletedMerchantList as DeletedMerchantListView,
  MerchantAdd as MerchantAddView,
  MerchantEdit as MerchantEditView,
  MerchantView as MerchantViewView,
  MerchantPDF as MerchantPDFView,
  DeletedMerchantView as DeletedMerchantView,
  SearchView,
  LoginView,
  PasswordResetView,
  ForgotPasswordView,
  Profile as ProfileView,
  Members as MembersView,
  AgreeToTerms as AgreeToTermsView,
  MembershipSignUp as MembershipSignUpView,
  MembershipSignUpNew as MembershipSignUpViewNew,
  TermsOfUse as TermsOfUseView,
  PrivacyPolicy as PrivacyPolicyView,
  DisputeProcess as DisputeProcessView,
  DisputePolicy as DisputePolicyView,
  DevelopersNew as DevelopersNewView,
  Api as ApiV1View,
  DisputeAdd as DisputeAddView,
  MFARegistration as MFARegistrationView,
  MFAVerification as MFAVerificationView,
  MerchantSubscriptionList as MerchantSubscriptionListView,
  MerchantSubscriptionImportList as MerchantSubscriptionImportListView,
  MerchantSubscriptionWebhookLogs as MerchantSubscriptionWebhookLogsView,
  MerchantScrubberImportList as MerchantScrubberImportListView,
  BrokerList as BrokerListView,
  Pro as ProView
} from './views';

import Gateway from './views/Auth/Login/Gateway.js';
export const history = createBrowserHistory()

// const history = createBrowserHistory()

// const HistoryRouter = props => {
// // export function HistoryRouter() {
//   const { history, basename, children} = props;
  
//   let [state, setState] = React.useState({
//     action: history.action,
//     location: history.location,
//   })

//   React.useLayoutEffect(() => history.listen(setState), [history])

//   return (
//     <ReactRouter
//         basename={basename}
//         children={children}
//         location={state.location}
//         navigationType={state.action}
//         navigator={history}
//   />
//   )
// }

// // export const history = createBrowserHistory()

// let currentRoute = history.location
// history.listen((nextRoute) => {
//   if (currentRoute.pathname === nextRoute.pathname &&
//     currentRoute.search === nextRoute.search &&
//     currentRoute.hash === nextRoute.hash) return
//   currentRoute = nextRoute
//   store.dispatch({ type: 'ROUTE_CHANGE' })
// })

export const router_history = history;

const Router = props => {
  const { is_dm_admin} = props

  let MerchantShowView = (<Route path="/" element={<MainLayout />}>
    <Route path="/merchants/:id" element={<MerchantViewView />} />
  </Route>)

  if (is_dm_admin){
    MerchantShowView = (<Route path="/" element={<DMAdminLayout />}>
      <Route path="/merchants/:id" element={<MerchantEditView />} />
    </Route>)
  }

  return (
    <BrowserRouter history={history}>
      <Routes>
        {/* <Redirect
          exact
          from="/"
          to="/login"
        /> */}

        <Route path="/" element={<AuthLayout />}>
          <Route index element={<LoginView />} />
          <Route path="/login" element={<LoginView />} />
          <Route path="/gateway" element={<Gateway />} />
          <Route path="/password_reset" element={<PasswordResetView />} />
          <Route path="/forgot_password" element={<ForgotPasswordView />} />
          {/* <Route path="/dispute" element={<DisputeAddView />} /> */}
        </Route>
        <Route path="/" element={<MinimalLayout />}>
          <Route path="/membership" element={<MembershipSignUpViewNew />} />
          <Route path="/terms_of_use" element={<TermsOfUseView />} />
          <Route path="/privacy_policy" element={<PrivacyPolicyView />} />
          <Route path="/dispute_policy" element={<DisputePolicyView />} />
          <Route path="/pro" element={<ProView />} />
          <Route path="/agree_to_terms" element={<AgreeToTermsView />} />
          <Route path="/mfa_registration" element={<MFARegistrationView />} />
          <Route path="/mfa_verification" element={<MFAVerificationView />} />
          <Route path="/not-found" element={<NotFoundView />} />
          <Route path="/dispute_process" element={<DisputeProcessView />} />
        </Route>
        <Route path="/" element={<AuthLayout />}>
          <Route path="/dispute" element={<DisputeAddView />} />
        </Route>
        <Route path="/" element={<MainLayout />}>
          <Route path="/developers" element={<DevelopersNewView />} />
          <Route path="/dashboard" element={<DashboardView />} />
          <Route path="/dashboardold" element={<DashboardOldView />} />
          <Route path="/analytics" element={<AnalyticsView />} />
          <Route path="/members" element={<MembersView />} />
          <Route path="/merchants/new" element={<MerchantAddView />} />
          <Route path="/profile" element={<ProfileView />} />
          <Route path="/search" element={<SearchView />} />
          <Route path="/merchant_subscriptions" element={<MerchantSubscriptionListView />} />
          <Route path="/merchant_subscription_imports" element={<MerchantSubscriptionImportListView />} />
          <Route path="/merchant_subscription_webhook_logs" element={<MerchantSubscriptionWebhookLogsView />} />
          <Route path="/merchant_scrubber" element={<MerchantScrubberImportListView />} />
          <Route path="/brokers" element={<BrokerListView />} />
        </Route>
        <Route path="/" element={<AdminLayout />}>
          <Route path="/account" element={<AccountView />} />
          <Route path="/account/members/new" element={<UserAddView />} />
          <Route path="/account/members/:id" element={<UserEditView />} />
        </Route>
        <Route path="/" element={<DMAdminLayout />}>
          <Route path="/funders" element={<AccountListView />} />
          <Route path="/funders/new" element={<AccountAddView />} />
          <Route path="/funders/:id" element={<AccountEditView />} />
          <Route path="/funders/:funder_id/members/new" element={<UserAddView />} />
          <Route path="/funders/:funder_id/members/:id" element={<UserEditView />} />
          <Route path="/merchants" element={<MerchantListView />} />
          <Route path="/deleted-merchants" element={<DeletedMerchantListView />} />
          <Route path="/deleted-merchants/:id" element={<DeletedMerchantView />} />
          <Route path="/settings" element={<SettingsView />} />
        </Route>
        {MerchantShowView}
        <Route path="/" element={<BlankLayout />}>
          <Route path="/merchants/:id/pdf" element={<MerchantPDFView />} />
        </Route>
        {/* <Route path="/" element={<Navigate to="/dashboard" replace={true} />}></Route> */}
      </Routes>
    </BrowserRouter>
  );
};

const mapStateToProps = state => {
  return {
    is_admin: state.auth.user.is_admin,
    is_dm_admin: state.auth.user.is_dm_admin,
    token: state.auth.token 
  }
}

export default connect(mapStateToProps)(Router)
